import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { Country } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

// **************************************************************************
// COUNTRIES ACTIONS
// **************************************************************************
export const CountriesActions = createActionGroup({
    source: "Data / Countries",
    events: {
        "Load": emptyProps(),
        "Load Success": props<{ country: Country | null }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
